// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"6aaadd2d51f5af29a340","966":"ca987d9f5f32da9a36a2"}[chunkId] + ".js";
};